import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IDProofModel } from '../../models/IDProofModel'


export interface IDProofState {
    IDProof: IDProofModel
    IDProofList: IDProofModel[]
}

const initialState: IDProofState = {
    IDProof: {} as IDProofModel,
    IDProofList: [],
}

export const IDProofSlice = createSlice({
    name: 'idProof',
    initialState,
    reducers: {
        setIDProof: (state, action: PayloadAction<IDProofModel[]>) => {
            state.IDProofList = action.payload
        },
        saveIDProof: (state, action: PayloadAction<IDProofModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: IDProofModel = { Id: 0, IDProofName: room.IDProofName }
                let currentRoom =
                    state.IDProofList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.IDProofName = room.IDProofName
            } else {
                room.Id = (Math.max(...state.IDProofList.map((c) => c.Id)) || 0) + 1
                state.IDProofList.push(room)
            }
        },
        getIDProofById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let idProof: IDProofModel = {} as IDProofModel
            if (id > 0) {
                let currentIDProof: IDProofModel[] = state.IDProofList
                idProof = currentIDProof.find((c) => c.Id === id) || ({} as IDProofModel)
            }

            state.IDProof = idProof
        },
        deleteIDProof: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentIDProof: IDProofModel[] = state.IDProofList
                state.IDProofList = currentIDProof.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setIDProof, saveIDProof, getIDProofById, deleteIDProof } =
IDProofSlice.actions

export default IDProofSlice.reducer
